import React from 'react';
import { Box, Tooltip, Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { plPL } from '@mui/x-data-grid';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { DataGridToolbar } from '../../../../components/data-grid/DataGridToolbar';
import { piggyBankConfigColumns } from '../../../../services/column-definitions';
import PiggyBankDetails from './PiggyBankDetails';

export const PiggyBankList = props => {
  const { onOpenSidebar, hideSidebar, configs, queryCallback, loading, submitCallback } = props;
  const [openCompose, setOpenCompose] = React.useState(false);
  const [fullScreen, setFullScreen] = React.useState(false);
  const [editRowData, setEditRowData] = React.useState(null);

  const handleDetailsCheck = (data, doubleClick = false) => {
    setEditRowData(data);
    if (doubleClick) {
      setFullScreen(true);
    }
    setOpenCompose(true);
  };
  const [columns] = React.useState(piggyBankConfigColumns(handleDetailsCheck));

  const searchCallback = search => {
    queryCallback(search);
  };

  return (
    <Box sx={{ opacity: loading ? 0.5 : 1, height: '100%' }}>
      <PiggyBankDetails
        isOpenCompose={openCompose}
        parentFullScreen={fullScreen}
        onCloseCompose={() => {
          setOpenCompose(false);
          setFullScreen(false);
          setEditRowData(null);
        }}
        submitCallback={submitCallback}
        data={editRowData}
      />
      <Box display="flex" justifyContent="center">
        <Tooltip title="Dodaj konfigurację skarbonki" sx={{ mb: 1 }}>
          <Fab
            color="primary"
            aria-label="add"
            onClick={() => {
              setFullScreen(true);
              setOpenCompose(true);
            }}
          >
            <AddIcon style={{ fontSize: '30px' }} />
          </Fab>
        </Tooltip>
      </Box>
      <Box sx={{ minWidth: { md: 800 }, height: '100%' }}>
        <DataGridPro
          columns={columns}
          rows={configs}
          density="compact"
          disableColumnMenu={true}
          autoPageSize={false}
          rowsPerPageOptions={[10, 25, 50, 100]}
          pagination
          components={{
            Toolbar: DataGridToolbar
          }}
          componentsProps={{ toolbar: { onOpenSidebar, hideSidebar, miniView: true, searchCallback } }}
          localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
          disableSelectionOnClick
          onRowDoubleClick={params => handleDetailsCheck(params.row, true)}
          onRowClick={params => {
            setEditRowData(params.row);
            setFullScreen(true);
            setOpenCompose(true);
          }}
        />
      </Box>
    </Box>
  );
};
